
export async function post(url,request) {
  try {
    let response = await fetch(url, {
      method: "POST",
      body: request
    });
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    
  }
}

export async function get(url) {
  try {
    let response = await fetch(url, {
      method: "GET",
    });
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    
  }
}